import { useState, useEffect } from "react";
import axios from "axios";

const token = "154eee0765dab442ff78623fec0e6f6e";
const apiService = axios.create({
  baseURL: "https://apicricketchampion.in/apiv5/",
});

const wpService = axios.create({
  baseURL: "https://predictionguruji.org/wp-json/wp/v2/",
});

export const serverUrl = "https://apicricketchampion.in/apiv5/";

// ===============Banners From Wordpress Dashboard=====================
export const useBanners = () => {
  const [banners, setBanners] = useState({ 
    horizontal: null, 
    vertical: null, 
    square: null 
  });

  useEffect(() => {
    const getBanners = async () => {
      try {
        const res = await wpService.get("banner?_fields=id,title,acf");
        const data = res.data;

        // Find the first banner for each specific shape
        const hBanner = data.find(item => item.acf?.orientation === "horizontal");
        const vBanner = data.find(item => item.acf?.orientation === "vertical");
        const sBanner = data.find(item => item.acf?.orientation === "square");        

        setBanners({
          horizontal: hBanner ? hBanner.acf : null,
          vertical: vBanner ? vBanner.acf : null,
          square: sBanner ? sBanner.acf : null,
        });
      } catch (err) {
        console.error("Banner API Error:", err);
      }
    };
    getBanners();
  }, []);

  return banners;
};
// ===============/Banner From Dashboard=====================


export const fetchUpcomingMatches = () => {
  return apiService.get(`upcomingMatches/${token}`);
};

export const fetchLiveMatches = () => {
  return apiService.get(`liveMatchList/${token}`);
};

export const fetchrecentMatches = () => {
  return apiService.get(`recentMatches/${token}`);
};
export const fetchseriesList = () => {
  return apiService.get(`seriesList/${token}`);
};

// GET api
export const getAPIHandler = async (endPoint) => {
  try {
    const postRes = await axios.post(serverUrl + endPoint + "/" + token);
    return postRes.data;
  } catch (error) {
    // console.log("error is - ", error.response);
    return { error };
  }
};

// Post api
export const postAPIHandler = async (endPoint, value) => {
  try {
    const postRes = await axios.post(serverUrl + endPoint + "/" + token, value);
    return postRes.data;
  } catch (error) {
    // console.log("error is - ", error.response);
    return { error };
  }
};
